<template>
<div class="bump squeeze">

    <v-data-table
      :headers="osMarket"
      :items="osMarketData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="osTransact"
      :items="osTransactData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="osAd"
      :items="osAdData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="osOn"
      :items="osOnData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="osRev"
      :items="osRevData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <p>*Other possible revenue sources include "Scanner Sales" they have not been included as the R&D phase with Lighthouse Optics has not been completed.</p>
    <v-data-table
      :headers="osScan"
      :items="osScanData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="osRevScan"
      :items="osRevScanData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
</div>
</template>

<script>
export default {
  data() {
    return {
      osMarket: [
        {
          text: 'Pawtocol Market Marker Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osTransact: [
        {
          text: 'Pawtocol Transaction Fee Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osAd: [
        {
          text: 'Pawtocol Advertising Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osOn: [
        {
          text: 'Pawtocol Onboarding Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osRev: [
        {
          text: 'Total Opportunity at 1% Capture Rates',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osScan: [
        {
          text: 'Pawtocol Scanner Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osRevScan: [
        {
          text: 'Total Opportunity Including a Sellable Scanner',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' }
      ],
      osMarketData: [
        {
          value: false,
          name: 'Total Capturable Pet Market',
          one: '256,000,000'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          one: '1.00%'
        },
        {
          value: false,
          name: 'Pets on Pawtocol Platform',
          one: '2,560,000'
        },
        {
          value: false,
          name: 'Average Transactions Per Pet/Yr',
          one: '20'
        },
        {
          value: false,
          name: 'Average Value Per Data Transaction',
          one: '$2.5'
        },
        {
          value: false,
          name: 'Pawtocol Market Maker %',
          one: '2%'
        },
        {
          value: false,
          name: '',
          one: '$2,560,000'
        }
      ],
      osTransactData: [
        {
          value: false,
          name: 'Number of pet owners within capturable market',
          one: '168,000,000'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          one: '1.00%'
        },
        {
          value: false,
          name: 'Pet Owners on the Pawtocol Platform',
          one: '1,680,000'
        },
        {
          value: false,
          name: 'Pet Owners Willing to Participate in Loyalty Points Systems',
          one: '1,344,000'
        },
        {
          value: false,
          name: 'Average US Yearly Pet Expenditure',
          one: '612'
        },
        {
          value: false,
          name: 'Maximum Value of Goods and Services Transacted on Network',
          one: '$822,245,685'
        },
        {
          value: false,
          name: 'Pawtocol Transaction Fee',
          one: '0.5%'
        },
        {
          value: false,
          name: '',
          one: '$4,111,228'
        }
      ],
      osAdData: [
        {
          value: false,
          name: 'Cat and Dog Population Annual Spend',
          one: '$102,780,710,587'
        },
        {
          value: false,
          name: 'Digital Media Advertising Spend (Pet Industry) as a Percent of Industry Revenue',
          one: '1.50%'
        },
        {
          value: false,
          name: 'Total Capturable Digital Advertising Market',
          one: '$1,541,710,659'
        },
        {
          value: false,
          name: 'Pawtocol % Capture of Advertising Market',
          one: '1.00%'
        },
        {
          value: false,
          name: '',
          one: '$15,417,107'
        }
      ],
      osOnData: [
        {
          value: false,
          name: 'Price Per Day to Onboard',
          one: '$10,000'
        },
        {
          value: false,
          name: 'Average Number of Days to Onboard',
          one: '5'
        },
        {
          value: false,
          name: 'Pawtocol Onboard Capacity per Year',
          one: '50'
        },
        {
          value: false,
          name: '',
          one: '$2,500,000'
        }
      ],
      osRevData: [
        {
          value: false,
          name: 'Based on Conservative Capturable Markets',
          one: '$24,588,335'
        }
      ],
      osScanData: [
        {
          value: false,
          name: 'Number of pet owners within capturable market',
          one: '168,000,000'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          one: '1.00%'
        },
        {
          value: false,
          name: 'Pet Owners on Pawtocol Platform',
          one: '1,680,000'
        },
        {
          value: false,
          name: 'Pet Owners that Buy Electronic Tracking Devices',
          one: '604,800'
        },
        {
          value: false,
          name: 'Pet Owners on Platform Purchase Sensor Devices',
          one: '72,576'
        },
        {
          value: false,
          name: 'Hardware (Scanners) Sold',
          one: '72,576'
        },
        {
          value: false,
          name: 'Price Per Scanner (based on comparable)',
          one: '$300.00'
        },
        {
          value: false,
          name: '',
          one: '$21,772,800.00'
        }
      ],
      osRevScanData: [
        {
          value: false,
          name: '',
          one: '$46,361,135'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>